<template>
  <div id="mmi" class="container-fluid m-0 p-0">
    <MatrizMenu />
    <div class="pl-2 pr-2">
      <div class="col-md-12 bg-light matriz-peligro-content">
        <div class="collapse show" id="mer-collapse">
          <div class="encabezado" v-show="!$store.state.global_id_matriz_riesgo && !id_subclasificacion
            ">
            <h5 class="color_letra--encabezado">Contenido No Disponible</h5>
            <div class="dropdown">
              <span class="badge text-secondary dropbtn"><i class="fas fa-question-circle fa-lg"></i></span>
              <div class="dropdown_content">
                <p>
                  En este momento usted no tiene un Centro de Trabajo
                  seleccionado o no está con un peligro específico
                </p>
                <p>
                  Para seleccionar un Centro de Trabajo diríjase a la sección
                  <b>Lista Centro de Trabajo</b>, opciones del Centro de
                  Trabajo, <b>Editar</b>
                </p>
                <p>
                  Para seleccionar un peligro específico, en este mismo módulo
                  en opciones de la lista de matrices peligro, <b>Editar</b>
                </p>
              </div>
            </div>
          </div>

          <form v-on:submit.prevent="accion_formulario">
            <div class="row justify-content-center">
              <div class="col-lg-5">
                <label class="color_letra">Tipo de medida de intervención: *<span class="badge text-secondary"><i
                      class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title="Fuente, situación o acto con potencial de daños en términos de enfermedad o lesión a las personas, o una combinación de estos."></i></span></label>
                <select class="form-control form-control-sm btn_general" v-model="tipo_medida_intervencion"
                  @change="cargar_medidas" required :disabled="!$store.state.global_id_matriz_riesgo &&
                    !id_subclasificacion
                    ">
                  <option disabled selected value="">Selección</option>
                  <option value="Eliminación">Eliminación</option>
                  <option value="Sustitución">Sustitución</option>
                  <option value="Controles de Ingeniería">
                    Controles de Ingeniería
                  </option>
                  <option value="Controles Administrativos, Señalización, Advertencia">
                    Controles Administrativos, Señalización, Advertencia
                  </option>
                  <option value="Equipos/Elementos de Protección Personal">
                    Equipos/Elementos de Protección Personal
                  </option>
                </select>
              </div>
              <div class="col-lg-7">
                <label class="color_letra">Medidas de intervención: *<span class="badge text-secondary"><i
                      class="fas fa-question-circle fa-lg" data-toggle="tooltip" data-placement="right" data-html="true"
                      title=""></i></span></label>
                <br />
                <multiselect :disabled="!$store.state.global_id_matriz_riesgo &&
                  !id_subclasificacion
                  " class="form-control form-control-sm boton_texto" v-model="check_medidas_intervencion"
                  tag-placeholder="Agregar nueva medida de intervencion" placeholder="Buscar o agregar"
                  :options="medidas_intervencion" deselectLabel="Enter para quitar" selectedLabel="Seleccionado"
                  selectLabel="Agregar" :multiple="true" :taggable="true" :limit="2" @tag="agregar_nuevo_medida"
                  :close-on-select="false" :clear-on-select="false" :preserve-search="true" :preselect-first="true"
                  :spellcheck="true">
                </multiselect>
              </div>
            </div>
            <div class="row justify-content-center pt-5">
              <button v-show="$store.state.msp_c_key" type="button" @click="terminar_centro_trabajo"
                class="btn btn-sm btn-form font-weight-bold">
                TERMINAR MATRIZ DE PELIGROS
              </button>
              <button v-show="$store.state.global_id_matriz_riesgo" type="button" @click="
                es_guardar = false;
              accion_formulario();
              " class="btn btn-sm btn-form font-weight-bold">
                TERMINAR
              </button>
              <button type="submit" @click="es_guardar = true" class="btn btn-sm btn-form font-weight-bold"
                :disabled="!$store.state.global_id_matriz_riesgo">
                GUARDAR
              </button>
            </div>
          </form>
        </div>
        <div class="d-flex justify-content-end m-0 p-0">
          <a @click="collapsed = !collapsed" class="pb-0 mb-0" data-toggle="collapse" data-target="#mer-collapse"
            aria-expanded="false" aria-controls="collapseExample">
            <i :class="[collapsed ? 'fa-chevron-up' : 'fa-chevron-down', 'fa']"></i>
          </a>
        </div>
      </div>
    </div>
    <Mtm />
  </div>
</template>

<script>
// IMPORTACIÓN DE FIREBASE
import { firebase, auth, db } from "./../firebase";
import MatrizMenu from "@/components/MatrizMenu.vue";
import Mtm from "@/components/Mtm.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "mmi",
  components: {
    MatrizMenu,
    Mtm,
  },

  data() {
    return {
      tipo_medida_intervencion: "",
      medidas_intervencion: [],
      check_medidas_intervencion: [],

      id_peligro: "",
      id_subclasificacion: "",
      registrado_por: "",
      es_guardar: false,
      collapsed: true,
    };
  },

  created() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
    if (this.$store.state.global_id_matriz_riesgo) {
      //CARGAR DATOS DE LA BASE matriz_riesgo
      if (!this.$store.state.global_nuevo_peligro) {
        const docRef = db
          .collection("matriz_riesgo")
          .doc(this.$store.state.global_id_matriz_riesgo);
        docRef
          .get()
          .then((doc) => {
            this.id_peligro = doc.data().em_id_peligro;
            this.id_subclasificacion = doc.data().em_id_subclasificacion;
          })
          .catch((error) => {
            console.log(
              "Error en la carga del los datos en el Created: ",
              error
            );
          });
        const docRefCliente = db
          .collection("cliente_empresa")
          .doc(this.$store.state.msp_c_key);
        docRefCliente
          .get()
          .then((doc) => {
            this.registrado_por = doc.data().em_registrado_por;
          })
          .catch((error) => {
            console.log(
              "Error en la carga del registro por parte del cliente_empresa en el Created: ",
              error
            );
          });
      }
    }
  },

  methods: {
    terminar_centro_trabajo() {
      NProgress.start();
      this.limpiar_variables();
      this.$store.commit("mutation_limpiar_globales");
      NProgress.done();
      NProgress.remove();
    },

    async accion_formulario() {
      await NProgress.start();
      if (this.es_guardar) {
        if (
          this.$store.state.msp_c_key &&
          this.$store.state.global_id_matriz_riesgo
        ) {
          this.guardar_medidas_intervencion();
        }
      } else {
        this.limpiar_variables();
        this.$store.state.global_id_matriz_riesgo = "";
        this.$store.state.global_es_editar = false;
        this.$store.state.global_nuevo_peligro = false;
        this.limpiar_variables_globales();
        NProgress.done();
        NProgress.remove();
      }
    },

    async guardar_medidas_intervencion() {
      if (this.tipo_medida_intervencion == "Eliminación") {
        await db
          .collection("matriz_riesgo")
          .doc(this.$store.state.global_id_matriz_riesgo)
          .update({
            em_eliminacion: this.check_medidas_intervencion,
          });
      } else if (this.tipo_medida_intervencion == "Sustitución") {
        await db
          .collection("matriz_riesgo")
          .doc(this.$store.state.global_id_matriz_riesgo)
          .update({
            em_sustitucion: this.check_medidas_intervencion,
          });
      } else if (this.tipo_medida_intervencion == "Controles de Ingeniería") {
        await db
          .collection("matriz_riesgo")
          .doc(this.$store.state.global_id_matriz_riesgo)
          .update({
            em_controles_ing: this.check_medidas_intervencion,
          });
      } else if (
        this.tipo_medida_intervencion ==
        "Controles Administrativos, Señalización, Advertencia"
      ) {
        await db
          .collection("matriz_riesgo")
          .doc(this.$store.state.global_id_matriz_riesgo)
          .update({
            em_controles: this.check_medidas_intervencion,
          });
      } else if (
        this.tipo_medida_intervencion ==
        "Equipos/Elementos de Protección Personal"
      ) {
        await db
          .collection("matriz_riesgo")
          .doc(this.$store.state.global_id_matriz_riesgo)
          .update({
            em_equipos: this.check_medidas_intervencion,
          });
      }

      await this.limpiar_variables();
      NProgress.done();
      NProgress.remove();
    },

    async cargar_medidas() {
      let array = [];
      this.check_medidas_intervencion = [];
      this.medidas_intervencion = [];

      let docRef = db
        .collection("matriz_riesgo")
        .doc(this.$store.state.global_id_matriz_riesgo);
      await docRef.get().then((doc) => {
        if (this.tipo_medida_intervencion == "Eliminación") {
          if (doc.data().em_eliminacion)
            this.check_medidas_intervencion = doc.data().em_eliminacion;
        }
        if (this.tipo_medida_intervencion == "Sustitución") {
          if (doc.data().em_sustitucion)
            this.check_medidas_intervencion = doc.data().em_sustitucion;
        }
        if (this.tipo_medida_intervencion == "Controles de Ingeniería") {
          if (doc.data().em_controles_ing)
            this.check_medidas_intervencion = doc.data().em_controles_ing;
        }
        if (
          this.tipo_medida_intervencion ==
          "Controles Administrativos, Señalización, Advertencia"
        ) {
          if (doc.data().em_controles)
            this.check_medidas_intervencion = doc.data().em_controles;
        }
        if (
          this.tipo_medida_intervencion ==
          "Equipos/Elementos de Protección Personal"
        ) {
          if (doc.data().em_equipos)
            this.check_medidas_intervencion = doc.data().em_equipos;
        }
      });
      await db
        .collection("nuevo_control_medida")
        .where("cm_id_peligro", "==", this.id_peligro)
        .where("cm_id_subcla", "==", this.id_subclasificacion)
        .where("cm_medidas_intervencion", "==", this.tipo_medida_intervencion)
        .where("cm_registrado_por", "==", this.registrado_por)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            array.push(`${doc.data().cm_control_medida}`);
          });
        });

      this.medidas_intervencion = array;
      if (this.$store.state.global_es_editar) {
        this.medidas_intervencion = this.medidas_intervencion.concat(
          this.check_medidas_intervencion
        );
      }
    },

    agregar_nuevo_medida(newTag) {
      this.medidas_intervencion.push(newTag);
      this.check_medidas_intervencion.push(newTag);
    },

    limpiar_variables() {
      this.medidas_intervencion = [];
      this.check_medidas_intervencion = [];
      this.tipo_medida_intervencion = "";
      this.id_peligro = "";
      this.id_subclasificacion = "";
      this.registrado_por = "";
      this.es_guardar = false;
    },

    limpiar_variables_globales() {
      this.$store.state.mip_id_proceso = "";
      this.$store.state.mip_id_zona = "";
      this.$store.state.mip_id_actividad = "";
      this.$store.state.mip_id_tareas = "";
      this.$store.state.mip_proceso = "";
      this.$store.state.mip_zona = "";
      this.$store.state.mip_actividad = "";
      this.$store.state.mip_tarea = [];
      this.$store.state.mip_rutinario = "";
    },
  },
};
</script>